'use client'

import type { Didomi } from '@/util/analytics'

import { waitForGppReady } from './gpp'
import { waitForTcfReady } from './tcf'

export type FreestarPrivacyFramework = 'none' | 'gpp' | 'tcf'

type PrivacyTarget = Pick<Window, '__gpp' | '__tcfapi'>

export function selectFreestarPrivacyFramework(didomi: Didomi): FreestarPrivacyFramework {
    if (didomi.isConsentRequired?.() === false) {
        return 'none'
    }

    let regulation: string | undefined
    try {
        regulation = didomi.getCurrentUserStatus?.().regulation
    } catch {
        return 'gpp'
    }

    return regulation?.trim().toUpperCase() === 'GDPR' ? 'tcf' : 'gpp'
}

export function waitForFreestarPrivacyReady(didomi: Didomi, target: PrivacyTarget = window): Promise<void> {
    const framework = selectFreestarPrivacyFramework(didomi)
    if (framework === 'none') {
        return Promise.resolve()
    }
    if (framework === 'tcf') {
        return waitForTcfReady(target)
    }
    return waitForGppReady(target).then(() => undefined)
}
